import { render, staticRenderFns } from "./FrDetection.vue?vue&type=template&id=224d7fb3"
import script from "./FrDetection.vue?vue&type=script&lang=js"
export * from "./FrDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports